import { render, staticRenderFns } from "./waterEdit.vue?vue&type=template&id=6870f4b5&scoped=true&"
import script from "./waterEdit.vue?vue&type=script&lang=js&"
export * from "./waterEdit.vue?vue&type=script&lang=js&"
import style0 from "./waterEdit.vue?vue&type=style&index=0&id=6870f4b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6870f4b5",
  null
  
)

component.options.__file = "waterEdit.vue"
export default component.exports